import i18n from 'utils/translation/i18n'
import departmentsList from 'utils/departmentsList'
import rolesList from 'utils/rolesList'

export default {
   departments: {
      name: i18n.t('department'),
      required: false,
      stateName: 'departments',
      type: 'Dropdown2',
      options: departmentsList,
      isClearable: true,
      isMulti: true,
   },
   roles: {
      name: i18n.t('role'),
      required: false,
      stateName: 'roles',
      type: 'Dropdown2',
      options: rolesList,
      isClearable: true,
      isMulti: true,
   },
}